import { render, staticRenderFns } from "./EmailTableCell.vue?vue&type=template&id=ba41fa50&scoped=true"
import script from "./EmailTableCell.vue?vue&type=script&lang=js"
export * from "./EmailTableCell.vue?vue&type=script&lang=js"
import style0 from "./EmailTableCell.vue?vue&type=style&index=0&id=ba41fa50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba41fa50",
  null
  
)

export default component.exports